import script from "./PromoteStudentsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoteStudentsDialog.vue?vue&type=script&setup=true&lang=js"

import "./PromoteStudentsDialog.vue?vue&type=style&index=0&id=e0db9b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0db9b1e"]])

export default __exports__